import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Settings = forwardRef<SVGSVGElement, SvgIconProps>(
  function Settings(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M10.88 4l-.55 1.94c-.5.14-.99.34-1.43.6l-1.77-.99-1.58 1.58.98 1.77c-.25.44-.45.92-.59 1.43L4 10.88v2.24l1.94.55c.14.5.34.99.6 1.43l-.99 1.77 1.58 1.58 1.77-.98c.44.25.92.45 1.43.59l.55 1.94h2.24l.55-1.94c.5-.14.99-.34 1.43-.6l1.77.99 1.58-1.58-.98-1.77c.25-.44.45-.92.59-1.43l1.94-.55v-2.24l-1.94-.55c-.14-.5-.34-.99-.6-1.43l.99-1.77-1.58-1.58-1.77.98a6.26 6.26 0 00-1.43-.59L13.12 4h-2.24zM12 8a4 4 0 010 8 4 4 0 010-8zm0 1a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3z" />
      </SvgIcon>
    )
  },
)

export default Settings
